import { cn } from '@/shared/lib/utils'
import { Skeleton } from '@/shared/ui/skeleton'

const GUTTER_WIDTH = 12

type DataTableSkeletonProps = {
  columns: number
  rows?: number
  fillHeight?: boolean
  flush?: boolean
}

export function DataTableSkeleton({
  columns,
  rows = 10,
  fillHeight = false,
  flush = false
}: DataTableSkeletonProps) {
  const skeletonColumns = Array.from(
    { length: columns },
    (_, columnIndex) => `column-${columnIndex}`
  )
  const skeletonRows = Array.from({ length: rows }, (_, rowIndex) => `row-${rowIndex}`)

  return (
    <div
      className={cn(
        'bg-background overflow-x-auto',
        !flush && 'border border-[#e9e9e9] dark:border-[#333] rounded-sm',
        fillHeight && 'md:flex-1 md:min-h-0 md:overflow-auto'
      )}
    >
      <table className={cn('w-full border-collapse min-w-[600px]', fillHeight && 'md:h-full')}>
        <thead>
          <tr className={cn(!flush && 'border-b border-[#e9e9e9] dark:border-[#333]')}>
            {flush && (
              <th
                className="bg-background"
                style={{ width: GUTTER_WIDTH, minWidth: GUTTER_WIDTH, maxWidth: GUTTER_WIDTH }}
              />
            )}
            {skeletonColumns.map((columnId) => (
              <th
                key={columnId}
                className={cn(
                  'h-8 px-2 text-left border-r border-[#f1f1f1] dark:border-[#2a2a2a] last:border-r-0',
                  flush && 'border-b border-[#e9e9e9] dark:border-[#333]'
                )}
              >
                <Skeleton className="h-3 w-16 rounded-sm" />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {skeletonRows.map((rowId) => (
            <tr
              key={rowId}
              className={cn(
                flush
                  ? 'group last:border-b-0'
                  : 'border-b border-[#f1f1f1] dark:border-[#2a2a2a] last:border-b-0'
              )}
            >
              {flush && (
                <td
                  className="bg-background"
                  style={{ width: GUTTER_WIDTH, minWidth: GUTTER_WIDTH, maxWidth: GUTTER_WIDTH }}
                />
              )}
              {skeletonColumns.map((columnId) => (
                <td
                  key={`${rowId}-${columnId}`}
                  className={cn(
                    'h-8 px-2 border-r border-[#f1f1f1] dark:border-[#2a2a2a] last:border-r-0',
                    flush && 'border-b border-[#f1f1f1] dark:border-[#2a2a2a] group-last:border-b-0'
                  )}
                >
                  <Skeleton className="h-3 w-full max-w-[100px] rounded-sm" />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
